import { CheckIcon } from 'components/icons';
import React from 'react';
import styles from './squareradiofilter.module.scss';
const SquareRadioFilter = React.forwardRef(({ children, ...props }, ref) => (
  <label className={styles.label}>
    <input
      type="radio"
      {...props}
      className={styles.input}
      ref={ref}
      id={children}
    />
    <span className={styles.span}>
      <CheckIcon />
      <div className={styles.text}>{children}</div>
    </span>
  </label>
));

export default SquareRadioFilter;
